import { pxToEm, themeV2 } from '@insticator/insticator-ui'

/* ++++++++++ --------------- NEW IMPORT : STYLES --------------- ++++++++++ */
export default {
  '@global': {
    '.plantip': {
      textAlign: 'justify', 
      padding: pxToEm(8),
      wordBreak: 'normal'
    }
  },
  newimport: {
    position: 'relative',
    zIndex: 1,
    boxShadow: 'none !important',
    borderRadius: 0,
    '& > .collapsable': {
      '& .innerWrap': {
        padding: `0 !important`
      }
    },
    '& .sectioncard': {
      padding: `${pxToEm(32)} !important`,
      border: 0,
      '& .newimporttitle': {
        margin: `${pxToEm(8)} 0 ${pxToEm(24)}`
      }
    },
    '& label': {
      display: 'flex',
      color: themeV2.color.primary.main,
      fontWeight: 700,
      marginBottom: pxToEm(8)
    },
    '& .errormessage': {
      opacity: '0',
      display: 'block',
      color: themeV2.color.error.main,
      fontSize: pxToEm(14),
      marginTop: pxToEm(5),
      // animate in 
      animationName: 'fadeInDown',
      animationDelay: '0s',
      animationDuration: '.1s',
      animationFillMode: 'forwards'
    },
    '& .griditem, & .gridset': {
      marginBottom: pxToEm(24)
    },
    '& .datepickerdropdown': {
      '& .compare': {
        display: 'none'
      },
      '& .actionpanel': {
        justifyContent: 'flex-end !important' 
      }
    },
    '& .vendordropdown': {
      height: pxToEm(54),
      width: '100%'
    },
    '& .sourcecontent': {
      marginLeft: pxToEm(40),
      '& p': {
        marginBottom: pxToEm(16)
      }
    },
    '& .radio': {
      '& .radiospan': {
        width: pxToEm(20),
        height: pxToEm(20),
        '&::after': {
          top: pxToEm(4),
          left: pxToEm(4),
          width: pxToEm(8),
          height: pxToEm(8)
        }
      }
    },
    '& .type-checkbox': {
      marginBottom: pxToEm(8)
    },
    '& .name-disqusplan': {

    },
    '& .disabled-true': {
      pointerEvents: 'none'
    },
    '& .name-uploadingwarning': {
      marginBottom: pxToEm(24),
      opacity: 0.75
    }
  }
}; 